import { render } from "./IconLike.vue?vue&type=template&id=7e2476c5&scoped=true"
import script from "./IconLike.vue?vue&type=script&lang=js"
export * from "./IconLike.vue?vue&type=script&lang=js"

import "./IconLike.vue?vue&type=style&index=0&id=7e2476c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e2476c5"]])

export default __exports__